import React, { useEffect, useState } from "react";
import { useInjectReducer, useInjectSaga } from "redux-injectors";
import { actions, reducer, sliceKey } from "./slice";
import * as selectors from "./selectors";
import { useDispatch, useSelector } from "react-redux";
import { viewCorrectionSaga } from "./saga";
import { Modal, Tag, Typography, Space, Spin } from "antd";
import {
  ExclamationCircleOutlined,
  CheckCircleOutlined,
  ClockCircleOutlined,
  CloseOutlined,
} from "@ant-design/icons";
import { dateTimeToString } from "../../utils/formatter";

const { Text } = Typography;

const correctionTypeMapping = {
  acceptanceForm: "Acceptance Form",
  labellingForm: "Labelling Form",
  report: "Correction in Report",
  // Add more mappings as needed
};

const ViewCorrection = ({ onOpen, onClose, id }) => {
  useInjectReducer({ key: sliceKey, reducer: reducer });
  useInjectSaga({ key: sliceKey, saga: viewCorrectionSaga });
  const dispatch = useDispatch();

  const [isLoading, setIsLoading] = useState(false);
  const correctionData = useSelector(selectors.selectCorrectionData);
  const disputes = [...(correctionData?.underDisputes || [])].reverse();

  useEffect(() => {
    setIsLoading(true);
    dispatch(
      actions.fetchCorrectionData({
        id,
        onSuccess: () => {
          setIsLoading(false);
        },
        onFailure: () => {
          setIsLoading(false);
        },
      })
    );
  }, [dispatch, id]);

  return (
    <Modal
      visible={onOpen}
      onCancel={onClose}
      footer={null}
      width={900}
      closeIcon={
        <CloseOutlined style={{ fontSize: "16px", color: "#8c8c8c" }} />
      }
      title={
        <div
          style={{
            fontWeight: 600,
            fontSize: "18px",
            color: "#262626",
            lineHeight: "24px",
          }}
        >
          Corrections Trail - Order #{correctionData?.orderId}
        </div>
      }
      bodyStyle={{
        padding: "24px",
        maxHeight: "600px",
        overflowY: "auto",
        scrollBehavior: "smooth",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "18px",
        }}
      >
        {isLoading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "50vh",
            }}
          >
            <Spin size="large" />
          </div>
        ) : disputes.length === 0 ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "50vh",
              fontSize: "16px",
              color: "#cbc9c9ff",
              fontWeight: 600,
            }}
          >
            <Text>No corrections have been raised for this order yet.</Text>
          </div>
        ) : (
          disputes?.map((item, index) => (
            <div
              key={item.id || index}
              style={{
                border: "2px solid #dfdcdcff",
                borderRadius: "8px",
                padding: "16px",
                // boxShadow: "0 2px 8px rgba(0, 0, 0, 0.09)"
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "flex-start",
                  marginBottom: "12px",
                }}
              >
                <Space align="center" size={8}>
                  {item?.requestCorrections?.map((correction, index) => (
                    <Tag
                      key={index}
                      color={correction?.isResolved ? "blue" : "red"}
                      style={{
                        borderRadius: "4px",
                        fontSize: "16px",
                        fontWeight: 500,
                        padding: "2px 8px",
                        border: "none",
                      }}
                    >
                      {correctionTypeMapping[correction?.type] ||
                        correction?.type}
                    </Tag>
                  ))}
                  {item.isResolved === true ? (
                    <CheckCircleOutlined
                      style={{
                        color: "#52c41a",
                        fontSize: "20px",
                      }}
                    />
                  ) : (
                    <ExclamationCircleOutlined
                      style={{
                        color: "#fa8c16",
                        fontSize: "20px",
                      }}
                    />
                  )}
                </Space>
                <Text
                  style={{
                    fontSize: "16px",
                    color: "#8c8c8c",
                    fontWeight: 500,
                  }}
                >
                  #{correctionData?.underDisputes?.length - index}
                </Text>
              </div>

              <div style={{ marginBottom: "16px", marginLeft: "5px" }}>
                <Text
                  style={{
                    fontSize: "16px",
                    color: "#040404ff",
                    lineHeight: "22px",
                  }}
                >
                  {item.remark}
                </Text>
              </div>

              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <Space align="center" size={8}>
                  <ClockCircleOutlined
                    style={{ fontSize: "16px", color: "#8c8c8c" }}
                  />
                  <Text
                    style={{
                      fontSize: "14px",
                      color: "#8c8c8c",
                    }}
                  >
                    Raised: {dateTimeToString(item.raisedDate)}
                  </Text>
                </Space>
                {item.resolvedDate && (
                  <Space align="center" size={8}>
                    <CheckCircleOutlined
                      style={{ fontSize: "16px", color: "#52c41a" }}
                    />
                    <Text
                      style={{
                        fontSize: "14px",
                        color: "#8c8c8c",
                      }}
                    >
                      Corrected: {dateTimeToString(item.resolvedDate)}
                    </Text>
                  </Space>
                )}
              </div>
            </div>
          ))
        )}
      </div>
    </Modal>
  );
};

export default ViewCorrection;
